import _ from 'lodash';
export const memoizedPartial = (fn, ...args) => {
    let memoizedPartialFn;
    if (fn._memoizeCache) {
        memoizedPartialFn = fn._memoizeCache.get(args);
    }
    else {
        fn._memoizeCache = new WeakMap();
    }
    if (!memoizedPartialFn) {
        // @ts-expect-error
        memoizedPartialFn = _.partial(fn, ...args);
        fn._memoizeCache.set(args, memoizedPartialFn);
    }
    return memoizedPartialFn;
};
//# sourceMappingURL=memoized-partial.js.map